export default "__VITE_ASSET__DYYPxdHw__"